import {useEffect, useState} from "react";
import {fetch} from "../utils/api-wrapper";

// A date written as digits in text (a manual correction did) or unreadable shows as a dash
// instead of throwing and blanking the whole page.
export const formatLogDate = (value, lang) => {
    const date = new Date(typeof value === 'string' && /^\d+$/.test(value.trim()) ? Number(value) : value);
    if (value === null || value === undefined || Number.isNaN(date.getTime())) return '—';
    return Intl.DateTimeFormat(`${lang}-US`, {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
    }).format(date);
};

const LogHistory = ({data, invoiceId}) => {
    const [historyLogs, setHistoryLogs] = useState([]);
    const [selectedLog, setSelectedLog] = useState(null);
    // This wrapper lets the table own the scroll area while the diff card stays visible.
    const panelStyle = {
        display: 'flex',
        flexDirection: 'column',
        flex: '1 1 auto',
        minHeight: 0,
        overflow: 'hidden',
    };
    // Only the log list should scroll when there are many entries.
    const listStyle = {
        flex: '1 1 auto',
        minHeight: 0,
        overflowY: 'auto',
    };
    // Keep the column titles visible while the surrounding history panel scrolls.
    const stickyHeaderStyle = {
        position: 'sticky',
        top: 0,
        zIndex: 1,
        backgroundColor: '#f8f6f3',
    };
    // The diff card should remain attached to the bottom of the history panel.
    const detailsStyle = {
        flexShrink: 0,
    };

    function fetchHistoryLogs() {
        setHistoryLogs([]);
        setSelectedLog(null);

        fetch('/invoices/' + invoiceId + '/history', 'GET', {}, (response) => {
            setHistoryLogs(response.data.history);
        });

    }

    useEffect(() => {
        fetchHistoryLogs();
    }, [invoiceId]);


    return (
        <div className='d-flex flex-column border' style={panelStyle}>
            <div data-testid='log-history-list' style={listStyle}>
                <table className='table'>
                    <thead>
                    <tr>
                        <th style={stickyHeaderStyle}>Date</th>
                        <th style={stickyHeaderStyle}>Type</th>
                        <th style={stickyHeaderStyle}>{data.t.read('by')}</th>
                        <th style={stickyHeaderStyle}>Notes</th>
                    </tr>
                    </thead>
                    <tbody>
                    {historyLogs.map((log) => {
                        return (<tr
                            key={log['_id']}
                            className={selectedLog === log ? 'selected-log' : 'row-hover'}
                            onClick={() => setSelectedLog(log)}
                        >
                            <td>{formatLogDate(log['created_at'], data.t.lang)}</td>
                            <td>{log['event_type']}</td>
                            <td>{log['user'] ? log['user']['first_name'] + ' ' + log['user']['last_name'] : log['username']}</td>
                            <td>{log['notes']}</td>
                        </tr>);
                    })}
                    </tbody>
                </table>
            </div>
            {selectedLog != null ? (<div className='card m-1 font-xsmall log-details' data-testid='log-history-details' style={detailsStyle}>
                <div className='card-body d-flex'>
                    <div className='flex-grow-1 flex-1 p-2 flex-shrink-0 border-right'>
                        <h5>{data.t.read('before')}</h5>
                        {selectedLog['diff_backward']}
                    </div>
                    <div className='flex-grow-1 flex-1 p-2 flex-shrink-0'>
                        <h5>{data.t.read('after')}</h5>
                        {selectedLog['diff_forward']}
                    </div>
                </div>
            </div>) : null}
        </div>)
}

export default LogHistory
